module.exports = __webpack_public_path__ + "img/fondo-banner.7801b213.svg";